module.exports = __webpack_public_path__ + "img/second_icon.96f25eed.png";